
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  AI,
  Answer,
  AIGroup,
  Candidate,
  CandidateResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import * as echarts from "echarts";

@Component({})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: "" }) connectCode!: string;
  // public showDimensionDesc = false; //是否展示维度描述  mark: 需求变更->都不展示
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  @Prop({ default: false }) dataAllReady!: boolean;

  @Watch("dataAllReady")
  onDataReady(n: boolean) {
    if (n) {
      this.$nextTick(() => {
        this.setEcharts(this.all.dimensionReport);
      });
    }
  }

  groupLogo =
    "https://oss.hina.com/app/hina/2023/06/25/1aa4eff607c642b6c6aba3b4d16baedc.svg"; //兜底图标

  version = {
    default: 0,
    echarts: 1
  };

  //展示哪种版本（风格）
  get showVersion() {
    return this.option.versionId;
  }

  //是否分组展示
  public get isGroup() {
    return this.all.configGroup.showType === 1;
  }
  //模块展示
  public Show(p: string) {
    return this.all.reportShowConfig?.[p] !== 1;
  }
  // 分组的 常模数据展示
  normalValueListGroup(group: AIGroup) {
    const dList = Array.from(new Set(group.dimensionList));
    const list = dList.map((item, index) => {
      return {
        weight: `${Math.floor(item.dimensionWeight * 100)}%`,
        dimension: item.dimension,
        percent: item.dimensionNormPercent,
        unanswered: item.unanswered
      };
    });

    return list;
  }
  // 是否常模 (非分组时 老规则)
  get isNormalValue() {
    return this.all.dimensionReport.every(item => item.hasNormData === 1);
  }
  //10 20 30 分三档时 颜色值
  getColor30(dim: AI | AIGroup) {
    return dim.dimensionLevel === 30
      ? "#19C976"
      : dim.dimensionLevel === 20
      ? "#FF9900"
      : "#F72D20";
  }
  //分组 组评价
  getResTextByGroup(dim: AIGroup) {
    let t = ``;
    t = `候选人在本次AI面试的表现为<span class='ac ac20' style='color:${this.getColor30(
      dim
    )}'>${dim.dimensionLevelDesc}</span>`;
    return t;
  }

  // 维度-特判英语、普通话等
  specialJumpText(item: any) {
    if (
      item.dimension === "英语" &&
      this.all.englishAssessmentResult.totalLevel >= 0
    ) {
      return `候选人的英语口语水平${
        this.all.englishAssessmentResult.getLevel().tag
      }
			，在本次测评中综合${
        this.all.reportShowConfig.englishAssessmentShowType === 1
          ? "等级"
          : "成绩"
      }${this.all.englishAssessmentResult.totalLevel}${
        this.all.reportShowConfig.englishAssessmentShowType === 1 ? "/9" : ".0"
      }。
			`;
    }
    if (item.dimension === "普通话") {
      return `候选人的普通话水平${
        this.all.chineseAssessmentResult.getEval(this.all).tag
      }
			${
        !this.Show("hiddenIseChineseScorePercent")
          ? ""
          : `，在常模人群中处于${this.all.chineseAssessmentResult.prScore}%分位。`
      }`;
    }
    return item.reportDescription || "暂无评价";
  }
  specialJump(item: any) {
    if (item.dimension === "英语") {
      const english = document.querySelector(".englishCard") as HTMLElement;
      english.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    if (item.dimension === "普通话") {
      const mandarin = document.querySelector(".mandarinCard") as HTMLElement;
      mandarin.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
  created() {
    //
  }

  //
  mounted() {
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }
  setEcharts(r: any) {
    if (!this.$refs.ecScore) return;
    if (!this.$refs.ecWeight) return;
    if (r.length === 0) return;
    // this.scoreTotal = 0;
    // this.scoreTotalAll = 0;
    this.optionRadar.series[0].data[0].value = [];
    this.optionRadar.radar.indicator = [];
    this.optionPie.series[0].data = [];

    r.forEach((d: any, index: number) => {
      // this.scoreTotal += d.score; // 总得分
      // this.scoreTotalAll += d.scoreAll; //总分
      this.optionRadar.radar.indicator.push({
        name: d.dimension,
        max: d.scoreAll
      });
      //雷达数据
      this.optionRadar.series[0].data[0].value.push(d.score > 0 ? d.score : 0);
      //饼图数据
      this.optionPie.series[0].data.push({
        name: d.dimension,
        value: d.scoreAll
      });
    });

    if (r.length === 1) {
      this.optionPie.series[0].padAngle = 0;
    }

    //AI表格
    this.AIList = r || [];
    this.$nextTick(() => {
      //雷达
      const echartScore = echarts.init(this.$refs.ecScore as HTMLDivElement);
      echartScore.setOption(this.optionRadar);
      //饼图
      const echartsR = echarts.init(this.$refs.ecWeight as HTMLDivElement);
      echartsR.setOption(this.optionPie);
    });
  }

  //AI维度
  AIList: Array<{ dimension: string; score: number; scoreAll: number }> = [];
  // 得分雷达图配置
  optionRadar = {
    tooltip: {},
    legend: {
      left: "right",
      top: "bottom",
      orient: "vertical", //排列方向 horizontal
      textStyle: {
        color: "#8590A6",
        fontSize: 9
      },
      itemHeight: 10,
      itemWidth: 10,
      data: ["维度得分", "维度中位分"]
    },
    radar: {
      shape: "circle",
      splitNumber: 5, //几段线
      nameGap: 5, //名称和轴的距离
      radius: "60%", //65%
      splitArea: { areaStyle: { color: ["rgba(242, 249, 255, 1)"] } }, //背景区域
      splitLine: { lineStyle: { color: ["rgba(204, 211, 240, 1)"] } }, //极坐标
      axisLine: { lineStyle: { color: "rgba(204, 211, 240, 1)" } }, //轴线
      name: {
        textStyle: {
          fontSize: "12",
          fontWeight: 400,
          fontFamily: "PingFangSC-Regular",
          color: "rgba(17, 17, 17, 1)"
        }
      },
      indicator: [
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 }
      ]
    },
    series: [
      {
        name: "考察维度得分",
        type: "radar",
        silent: true, // 禁止交互
        symbol: "circle", //形状
        symbolSize: 2, // 拐点的大小
        itemStyle: {
          color: "rgba(255, 185, 4, 1)"
        },
        data: [
          {
            value: [0],
            name: ""
          }
        ],
        lineStyle: { color: "rgba(255, 185, 4, 1)", width: 1 },
        areaStyle: { color: "rgba(255, 185, 4, 0.50)" }
      }
    ]
  };
  //饼图用色
  colorList = [
    "#5458FF",
    "#EFA384",
    "#EF4139",
    "#FDB225",
    "#31BBF7",
    "#F8772F",
    "#19DFB0",
    "#C0EF39",
    "#9F2FF8",
    "#FDF425",
    "#39E4EF",
    "#F039A7"
  ];
  //权重饼状图配置
  optionPie = {
    tooltip: {
      trigger: "item",
      formatter: function(params: any) {
        return `${params.name}：${params.percent}%`;
      }
    },
    series: [
      {
        name: "考察维度权重",
        type: "pie",
        silent: true, // 禁止交互
        clockwise: false, //是否顺时针
        color: this.colorList,
        radius: ["35%", "60%"],
        label: {
          show: true,
          fontSize: 12,
          lineHeight: 12,
          color: "rgba(17, 17, 17, 1)",
          formatter: "{b}" + "\n" + "{d}%",
          position: "outer"
          // alignTo: "edge",
          // edgeDistance: "10%"
        },
        itemStyle: {
          borderWidth: 0,
          borderColor: "#FFFFFF"
        },
        padAngle: 1, //扇形之间的间隔
        emphasis: {
          scaleSize: 2,
          focus: "self",
          //聚焦态
          label: {
            show: true,
            fontSize: "12px",
            fontWeight: "bold"
          }
        },
        labelLine: {
          show: false,
          length: 12, //两段线 控制文字位置
          length2: 0
        },
        data: [{ value: 200, name: "A权重占比" }]
      }
    ]
  };
  getDimensionDesc(item: { score: number; scoreAll: number }): string {
    if (isNaN(item.score) || isNaN(item.scoreAll)) {
      console.warn("得分数据错误");
      return "-";
    }
    const percent = Math.round((item.score / item.scoreAll) * 100);
    let judge = percent >= 70 ? "优秀" : percent >= 30 ? "中等" : "欠佳";
    return judge;
  }
}
